"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = void 0;
var assert_1 = require("tsafe/assert");
Object.defineProperty(exports, "assert", { enumerable: true, get: function () { return assert_1.assert; } });
//# sourceMappingURL=assert.js.map